import { AuthenticateService } from './authenticate.service';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import * as moment from 'moment';
import { EHR_SERVICE, HOST_EHR } from 'src/util/constants';
import { DocumentService } from './document.service';
import { ProfissionalService } from './profissional.service';
moment.locale('pt-br');

@Injectable({
  providedIn: 'root'
})
export class PrescricaoService {

  constructor(
    private http: RequestService,
    private auth: AuthenticateService,
    private documentService: DocumentService,
    private profissionalService: ProfissionalService
  ) {

  }

  async getPrescricao() {
    try {
      let jwtDecode: any = await this.auth.getDecodeToken();
      if (jwtDecode.cnsPaciente) {
        let cns = jwtDecode.cnsPaciente;
        let composition = `${EHR_SERVICE}/api/fhir/r4/List?subject=Patient/${cns}&code=http://www.saude.gov.br/fhir/r4/CodeSystem/BRClassificacaoLista%7Cprescriptions`
        let data: any = await this.http.get(composition, null, this.getHeadersContextText()).then();

        console.log('===============data', data);

        let nextPage: any = '';
        let result: any[] = [];
        if (data && data.entry) {
          let list = data.entry[0];
          if (list.resource.entry) {
            result = await this.loadEntryList(list.resource.entry);
          }
        }
        return result;
      }
      return [];
    } catch (e) {
      console.log('==============error', e);

      return []
    }
  }

  loadDetailPresc(presc) {

    let separar = presc.split('/');

    let composition = `${presc}/$document`
    return this.http.get(composition, null, this.getHeadersContextText()).then(data => {
      return data;
    }).catch((error) => {
      return [];
    });
  }

  loadEntryList(data) {
    let Promises = [];
    for (const item of data) {
      Promises.push(this.get(item.item.reference));
    }
    return Promise.all(Promises);
  }

  async getOrganizationInfo(cnes) {
    return this.http.get(EHR_SERVICE + '/api/fhir/r4/Organization/' + cnes, null, await this.getHeadersContextText()).then(data => {
      return data;
    }).catch((error) => {
      return {};
    });
  }

  async getCodeSystem(coding, keySystem = null) {
    let valor: {
      code: string;
      display: string;
    } = { code: null, display: null };
    let busca;
    if (keySystem) {
      coding.forEach(cod => {
        if (cod.system.includes(keySystem)) {
          busca = cod;
        }
      });
    } else {
      busca = coding[0];
    }
    valor.code = busca.code;
    const cable: any = await this.documentService.getReadSystem(busca);
    valor.display = '-';
    if (cable && cable.parameter) {
      valor.display = cable.parameter.find((data) => (data.name == 'display')).valueString;
    }
    return valor;
  }

  async get(reference: any) {
    let detail: any = await this.loadDetailPresc(reference);

    if (detail && detail.entry.length > 0) {

      const document: any = {
        id: reference,
        coCnes: '',
        nmEstabelecimento: '',
        endereco: '',
        nmProfissional: '',
        dataHoraPrescricao: '',
        crmProfissional: '',
        ufProfissional: '',
        status: true,
        descricaoMedicamento: '',
        medicamentos: []
      };


      await Promise.all(detail.entry.map(async (element) => {
        if (
          element.resource.resourceType == "Composition" &&
          element.resource.meta.profile[0].includes('BRRegistroPrescricaoMedicamento')
        ) {
          if (element.resource.author && element.resource.author.length > 0) {
            await Promise.all(element.resource.author.map(async (author) => {
              if (author.identifier.system.includes('BREstabelecimentoSaude')) {
                document.coCnes = author.identifier.value;

                const estabelecimento: any = await this.getOrganizationInfo(document.coCnes);
                document.nmEstabelecimento = estabelecimento.name;

                if (estabelecimento.address && estabelecimento.address.length > 0) {
                  const end = estabelecimento.address[0];

                  document.endereco = `${end.line ? end.line.join(' - ') : ''} - ${end.city}, ${end.state} `;
                }


              }
            }));
          }
        }

        if (
          element.resource.meta.profile[0].includes('BRPrescricaoMedicamento')
        ) {
          document.dataHoraPrescricao = moment(element.resource.authoredOn).format('DD/MM/YYYY HH:mm');

          if (element.resource.note && element.resource.note.length > 0) {
            document.descricaoMedicamento = element.resource.note[0].text;
          }

          if (element.resource.medicationReference) {

            try {
              const medicamento = detail.entry.find(e => e.resource.meta.profile[0].includes('BRMedicamento') && `${e.resource.resourceType}/${e.resource.id}` == element.resource.medicationReference.reference);

              console.log('=======medicamento', medicamento);


              const detalheMedicamento = await this.getCodeSystem(medicamento.resource.code.coding, 'BRObmCATMAT');


              let unidade = '';
              let dosagem = '';
              let instrucao = '';
              let viaAdministracao = '';
              let tempoUso = '';
              let descricao = '';
              let seNecessario = '';
              let doseUnica = '';
              let turno = '';
              let intervalo = '';
              let uniIntervalo = '';
              let maxDosePerAdministration = '';
              if (element.resource.dosageInstruction) {

                const dosageInstruction = element.resource.dosageInstruction[0];
                seNecessario = dosageInstruction.asNeededBoolean ? 'Sim' : 'Não';
                instrucao = dosageInstruction.patientInstruction;
                descricao = dosageInstruction.text;
                maxDosePerAdministration = dosageInstruction.maxDosePerAdministration.value;
                const via = await this.getCodeSystem(dosageInstruction.route.coding, 'BRViaAdministracao');
                viaAdministracao = via.display;


                const doseAndRate = dosageInstruction.doseAndRate[0];
                dosagem = doseAndRate.doseQuantity.value;
                const u = await this.getCodeSystem(doseAndRate.type.coding, 'BRUnidadeMedida');
                unidade = u.display;

                if (dosageInstruction.timing) {
                  if (dosageInstruction.timing.repeat.count == dosageInstruction.timing.repeat.countMax) {
                    doseUnica = 'Sim';
                  } else {
                    doseUnica = 'Não';
                  }


                  if (dosageInstruction.timing.repeat.extension) {
                    await Promise.all(dosageInstruction.timing.repeat.extension.map(async ext => {

                      if (ext.url.includes('BRTurno')) {
                        const t = await this.getCodeSystem([{
                          system: 'http://www.saude.gov.br/fhir/r4/CodeSystem/BRTurno',
                          code: ext.valueCode
                        }]);

                        turno = t.display;
                      }

                      if (ext.url.includes('BRIntervaloDoses')) {
                        await Promise.all(ext.extension.map(async e => {
                          if (e.url == 'periodUnit') {
                            const u = await this.getCodeSystem([{
                              system: 'http://www.saude.gov.br/fhir/r4/CodeSystem/BRUnidadeTempo',
                              code: e.valueCode
                            }]);

                            uniIntervalo = u.display;
                          }
                          if (e.url == 'period') {
                            intervalo = e.valuePositiveInt;
                          }
                        }));
                      }


                    }));

                  }





                }


              }

              if (element.resource.dispenseRequest && element.resource.dispenseRequest.quantity) {
                tempoUso = element.resource.dispenseRequest.quantity.value + ' dias';


              }




              document.medicamentos.push({
                id: medicamento.resource.id,
                nome: detalheMedicamento.display,
                dosagem,
                unidade,
                descricao,
                instrucao,
                tempoUso,
                viaAdministracao,
                seNecessario,
                turno,
                intervalo,
                uniIntervalo,
                doseUnica,
                maxDosePerAdministration,
                quantidadeDose: `${dosagem} ${unidade}`
              });
            } catch (e) {
              console.error('=======', e);
            }


          }

          if (element.resource.recorder.identifier.system.includes('BRProfissional')) {
            let proff: any = await this.documentService.getReadFull(EHR_SERVICE + '/api/fhir/r4/Practitioner/' + element.resource.recorder.identifier.value);
            document.nmProfissional = proff.name[0].text;
            try {
              let prof: any = await this.profissionalService.recuperarTodosPorCnsCpf(element.resource.recorder.identifier.value);
              if (prof.nuCrm) {
                document.crmProfissional = prof.ufCrm;
                document.ufProfissional = prof.nuCrm;
              }
            } catch (err) {
              console.error('===prof crm===', err);
            }
          }
        }
      }));

      return document;
    }

    return {};
  }

  async getDetalhe(id) {
    return this.get(id);
  }

  getQrCode(id) {
    return false;
  }

  getMedicamento(id) {
    return false;

  }

  putMotivo(id, motivo = '') {
    return true;
  }

  getHeaders(access_token?) {
    return {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: access_token || this.auth.getAuthorizationToken()
    };
  }

  getHeadersToken() {
    return {
      Accept: '*/*',
      Authorization: this.auth.getAuthorizationToken(),
      'Content-Type': 'application/json'
    };
  }

  getHeadersContextText() {
    let server = JSON.parse(localStorage.getItem('app_icp_token'));
    const httpOptions = {
      'Content-Type': 'application/json',
      //'X-Authorization-Origin': ORIGIN,
      //'X-Authorization-Audience': 'prosus.saude.gov.br',
      //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
      'X-Authorization-Server': 'Bearer ' + server.access_token,
      'Authorization': 'Bearer ' + this.auth.getAuthorizationToken(),
    };

    return httpOptions;
  }
}
